import React, { useState, useEffect } from "react";
import styled from "styled-components";
import ApiController from "../controller/ApiController";
import { useRecoilState, useRecoilValue } from "recoil";
import {
  authState,
  authStoreType,
  authType,
  masterStoreState,
} from "../recoil/auth";
import { AreaType, RoomType } from "../controller/MasterController";
import { langState, langText } from "../recoil/lang";

type SelectedRoomType = {
  area_number: number;
  room_list: RoomType[];
};

const RoomSelect: React.FC<any> = ({
  selectedArea,
  selectedRoom,
  setSelectedArea,
  setSelectedRoom,
  setAreaName,
  setRoomName,
}) => {
  const master = useRecoilValue<authStoreType | null>(masterStoreState);
  const [lang, setLang] = useRecoilState<number>(langState);
  const [areaList, setAreaList] = useState<AreaType[]>([]);
  const [roomList, setRoomList] = useState<SelectedRoomType>({
    area_number: -1,
    room_list: [],
  });

  const onChangeArea = (item: AreaType) => {
    setSelectedArea(item.area_number);
    setRoomList({
      area_number: item.area_number,
      room_list: item.room_list,
    });
    setAreaName(item.area_name);
    setSelectedRoom(-1);
  };

  // 구역 불러오기
  const getArea = async () => {
    try {
      if (master) {
        const response = await ApiController.area.getArea(master.store_id);
        if (response && response.data) {
          setAreaList(response.data.data);
        }
      }
    } catch (err) {
      console.error("getArea error:", err);
    }
  };

  useEffect(() => {
    getArea();
  }, []);
  useEffect(() => {
    if (areaList.length > 0) {
      setRoomList({
        area_number: areaList[0].area_number,
        room_list: areaList[0].room_list,
      });
      setSelectedArea(areaList[0].area_number);
    }
  }, [areaList]);

  return (
    <Style>
      <div className="listWrap">
        <div className="sideListWrap">
          <h2>{langText.floor_label[lang]}</h2>
          {areaList.map((item: AreaType) => (
            <div
              onClick={() => onChangeArea(item)}
              className={` selectedButton ${
                selectedArea === item.area_number ? "activeFloor" : ""
              }`}
              key={item.area_number}
            >
              <h2>{item.area_name}</h2>
            </div>
          ))}
        </div>
        <div className="sideListWrap">
          <h2>{langText.room_label[lang]}</h2>
          {roomList.room_list.map((item: RoomType) => (
            <div
              className={`selectedButton area ${
                selectedRoom === item.number ? "activeArea" : ""
              }`}
              key={item.number}
              onClick={() => {
                setSelectedRoom(item.number);
                setRoomName(item.name);
              }}
            >
              <h2>{item.name}</h2>
            </div>
          ))}
        </div>
      </div>
    </Style>
  );
};

export default RoomSelect;

const Style = styled.div`
  h2 {
    font-size: 24px;
    font-weight: 500;
    color: #fff;
  }

  .listWrap {
    display: flex;
    padding: 0 70px;
    height: 100%;
    gap: 40px;

    .sideListWrap {
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .selectedButton {
      width: 100%;
      margin-top: 16px;
      padding: 16px;
      border: 2px solid #555555;
      border-radius: 5px;
      text-align: center;
    }
    .selectedButton.activeFloor {
      background: #40977f;
      border-color: #40977f;
    }
    .selectedButton.area {
      border: none;
    }
    .selectedButton.activeArea {
      border: 2px solid #4dd2ae;

      h2 {
        color: #4dd2ae;
      }
    }
  }
`;
